import { Box, type BoxProps } from '@chakra-ui/react';
import type { PropsWithChildren } from 'react';

interface PageSurfaceProps extends BoxProps {
  surfaceProps?: BoxProps;
}

export const PageSurface = ({
  children,
  surfaceProps,
  ...outerProps
}: PropsWithChildren<PageSurfaceProps>) => {
  // The app content panel (Layout's main box) is now the rounded white surface,
  // so PageSurface no longer paints its own card. It stays a structural wrapper:
  // full height + internal clipping for pages that manage their own scroll.
  return (
    <Box h="full" minH={0} boxSizing="border-box" {...outerProps}>
      <Box h="full" minH={0} overflow="hidden" {...surfaceProps}>
        {children}
      </Box>
    </Box>
  );
};
